export default __webpack_public_path__ + "locales/vi/UploadPanel.json?hash=358fd01de0c214d489118ebf6c0d2467";